webpackJsonp([24],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(481)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/3dsharelist/3dsharelist.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] 3dsharelist.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f091ca06", Component.options)
  } else {
    hotAPI.reload("data-v-f091ca06", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3dsharelist_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3dsharelist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3dsharelist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = el.dataset.title;
  },
  update: function update(el, binding) {
    document.title = el.dataset.title;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__3dsharelist_vue___default.a);
  }
}).$mount('#privacy');

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.2rem;\n  text-align: justify;\n  height: auto;\n  word-break: break-all;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div {\n  margin: 0.01rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n  margin: 0.1rem 0rem;\n}\n#privacy div .sub-title {\n  font-weight: 500;\n  margin-top: 0.08rem;\n}\n#privacy div .sub-title.group {\n  margin-top: 0.3rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("腾讯Bugly SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("收集崩溃信息，提升App质量，提供异常日志分析服务")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("在程序异常时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("设备唯一识别码(IMEI/MEID/AndroidID/IDFA/OPENUDID/IDFV/出厂序列号/SIM卡IMSI)")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("华为推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("提供消息推送服务")]), _vm._v(" "), _c('div', [_vm._v("统计华为推送SDK接口调用成功率。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("手机在后台时，需要收到会议邀请时进行提醒展示")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("华为软件技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("友盟SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("内容分享，用户行为分析")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("内容分享到第三方软件")]), _vm._v(" "), _c('div', [_vm._v("用户使用功能次数记录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("友盟同欣(北京)科技有限公司、北京瑞讯灵通科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("小米推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("为用户提供推送")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("手机在后台时，需要收到会议邀请时进行提醒展示")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("Mac地址、WiFi SSID、访问电话状态、获取网络信息、设备型号/名称、设备制造商、手机品牌、系统的API级别数字/字符、运行程序列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("北京小米科技有限责任公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("VIVO推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向VIVO手机用户推送消息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("获取任务信息、获取网络信息、设备制造商、系统的API级别数字/字符、运行程序列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("维沃移动通信有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("OPPO推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向OPPO手机用户推送消息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("系统的API级别数字/字符")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("OPPO广东移动通信有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("极光推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向OPPO手机用户推送消息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("获取任务信息、获取网络信息、设备制造商、系统的API级别数字/字符、运行程序列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("深圳市和讯华谷信息技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("阿里云OSS对象存储SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("上传图片、缓存数据")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("允许联网、获取网络状态、判断网络状态、获取本地存储")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("北京阿里巴巴云计算技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("声网SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("提供视频与音频会议功能")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("设备类型、设备型号、CPU信息、电池电量信息、操作系统信息")]), _vm._v(" "), _c('div', [_vm._v("收发端用户ID、用户属性、频道信息、使用时长、频道内设置名称、日志")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("上海兆言网络科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("魅族PUSH")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向魅族手机用户消息推送")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("网卡（MAC）地址、国际移动设备识别码（IMEI）、独立设备标识符、IP地址、设备型号、操作系统版本、电池、信号强度")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("珠海市魅族科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("MobTech ShareSDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("提供社交分享、第三方登录社交分享、第三方登录功能")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("内容分享和第三方登录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("系统信息；WIFI状态信息；应用列表信息；基站信息；地理位置")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("上海游昆信息技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("支付宝SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("支付")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("购买VIP服务等")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、Android ID、SSID、BSSID、设备基础信息【机型\\厂商等】）、网络信息。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("支付宝(中国)网络技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("微信SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("支付")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("购买VIP服务等")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("MAC地址、唯一设备识别码")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(12)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/179ae701076241418eaf276f7595ee54"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/179ae701076241418eaf276f7595ee54")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy"
    }
  }, [_vm._v("https://www.umeng.com/page/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/652"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/652")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://open.oppomobile.com/wiki/doc#id=10288"
    }
  }, [_vm._v("https://open.oppomobile.com/wiki/doc#id=10288")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.jiguang.cn/license/privacy"
    }
  }, [_vm._v("https://www.jiguang.cn/license/privacy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.131995.J_9220772140.87.581169fdsILQ3y"
    }
  }, [_vm._v("http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.131995.J_9220772140.87.581169fdsILQ3y")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.agora.io/cn/privacy-policy"
    }
  }, [_vm._v("https://www.agora.io/cn/privacy-policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.mob.com/about/policy"
    }
  }, [_vm._v("https://www.mob.com/about/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://docs.open.alipay.com/54"
    }
  }, [_vm._v("https://docs.open.alipay.com/54")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
    }
  }, [_vm._v("https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f091ca06", module.exports)
  }
}

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(381);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9329d904", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f091ca06\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./3dsharelist.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f091ca06\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./3dsharelist.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ })

},[252]);


// WEBPACK FOOTER //
// static/js/module/3dsharelist.918b9d3389527a5a2ba3.js